import React from 'react'
import TableWithPagination from './TableWithPagination'
import useInventory from '../hooks/useInventory'
import { filterMap, bodyMap, sortMap } from '../maps'
import DetailedResponse from './DetailedResponse'

function InventoryList() {

    const {
        loading,
        activeRecord,
        columns,
        records,
        currentPage,
        totalPages,
        sort,
        onPageChange,
        onPrevPage,
        onNextPage,
        onFilter,
        onSort,
        onActiveRecord
    } = useInventory()

    return (
        <div>
            <div className={`table-wrapper ${loading ? 'pointer-events-none' : ''}`}>
                <TableWithPagination {...{
                    loading,
                    activeRecord,
                    columns,
                    records,
                    currentPage,
                    totalPages,
                    sort,
                    onPageChange,
                    onPrevPage,
                    onNextPage,
                    filterMap: filterMap,
                    onFilter,
                    onSort,
                    onActiveRecord,
                    bodyMap: bodyMap,
                    sortMap: sortMap
                }} />
                {loading && <div className='ccs-custom-loader'>Loading...</div>}
            </div>
            {activeRecord && activeRecord?.responseId && (<DetailedResponse responseId={activeRecord?.responseId} />)}
            {activeRecord && !activeRecord?.responseId && <div>RESPONSE ID NOT PRESENT</div>}
        </div>
    )
}

export default InventoryList